import { Goal, GoalProgressCount, ID } from '@griply/types';

import { hasGoalReachedTarget } from '../has-goal-reached-target';

export const shouldShowGoalCompletionBanner = (
  goal: Goal | undefined,
  goalProgressCounts?: Map<ID, GoalProgressCount>,
): boolean =>
  !!goal &&
  !goal.completedAt &&
  !goal.metadata?.hideCompletionBanner &&
  hasGoalReachedTarget(goal, goalProgressCounts);
